import { createClient } from '@supabase/supabase-js';

// These values should be replaced with your actual Supabase URL and anon key
// You can find these in your Supabase project settings > API

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and anon key must be provided in environment variables');
}

// Create a single supabase client for interacting with your database
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
    site: 'The Icing Calculator',
    storageKey: 'icing-calculator-auth-storage'
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'x-my-custom-header': 'The Icing Calculator'
    }
  },
  // Configure retries for failed requests
  maxRetryAttempts: 3,
  retryInterval: 1000, // 1 second between retries
  // Configure timeouts
  realtime: {
    timeout: 20000 // 20 seconds
  }
});

export default supabase;
